<template>
  <b-form-group
    :label="label"
    :class="`${classFormGroupBind} b-form-group-styled`"
    :invalid-feedback="invalidFeedback"
    :description="descriptionField()"
    :state="error && error.$error ? false : null"
  >
    <InputFacade
      class="lg form-control b-form-input-styled"
      :value="selected"
      @input="($value) => $emit('input', $value)"
      v-bind="$attrs"
      :state="error && error.$error ? false : null"
    />
  </b-form-group>
</template>
<script>
/*
DOCUMENTAÇÃO: https://www.npmjs.com/package/vue-input-facade
Default Mask Tokens
  S = alpha characters
  # = numerical characters
  X = alpha numerical characters
  A = alpha characters, transformed to uppercase
  a = alpha characters, transformed to lowercase
  \ = escape any of the above characters

*/
import { InputFacade } from "vue-input-facade"

export default {
  components: { InputFacade },

  props: {
    cols: String,
    sm: String,
    md: String,
    classFormGroup: {
      type: String,
      default: "",
    },
    label: String,
    value: [String, Number],

    invalidFeedback: {
      typeof: String,
      default: null,
    },
    description: {
      typeof: String,
      default: "Digite um valor válido",
    },
    error: {
      type: Object,
      default: null,
    },
  },
  computed: {
    classFormGroupBind() {
      const responsiveCols =
        (this.cols !== undefined ? `col-${this.cols} ` : "") +
          (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
          (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 ";
      return `${responsiveCols} ${this.classFormGroup}`;
    },
    selected() {
      return this.value;
    },
  },
  methods: {
    descriptionField() {
      if (this.$attrs.readonly) {
        return "Não editável";
      }
      return !this.error || !this.error.$error ? this.description : "";
    },
  },
};
</script>

<style scoped>
.b-form-group-styled {
  font-size: 12px;
}
.b-form-input-styled {
  max-height: 21px;
  margin-top: -8px;
}
</style>
